import client from '../config/AxiosConfig';

export const GetInfo = async () => await client.get('/info');

export const GetTranslations = async () => await client.get('/translations/platform/BO');

export const GetDynamicPages = async () => await client.get('/dynamic_pages');

export const GetDynamicPage = async (tag) => await client.get(`/dynamic_pages/${tag}`);

export const CreateDynamicPage = async (data) => await client.post('/dynamic_pages', data);

export const UpdateDynamicPage = async (tag, data) => await client.put(`/dynamic_pages/${tag}`, data);

export const GetMetatags = async () => await client.get('/metatags');

export const GetMetatag = async (tag) => await client.get(`/metatags/${tag}`);

export const CreateMetatag = async (data) => await client.post('/metatags', data);

export const UpdateMetatag = async (tag, data) => await client.put(`/metatags/${tag}`, data);

export const GetLeaderBoard = async () => await client.get('/users/leaderboard/bo');

export const GetCountries = async () => await client.get("/countries");
